import styled from "@emotion/styled";
import { buttonPrimary, buttonPrimaryHover, buttonPrimaryPressed, neutralDark10 } from "../../../../constants/colors";
import { Clickable } from "../../../clickable";

export interface DatePickerCalendarButtonLodestarProps {
    isDisabled: boolean;
}

export const DatePickerCalendarButtonLodestar = styled(Clickable)<DatePickerCalendarButtonLodestarProps>`
    height: 24px;
    width: 24px;

    display: flex;

    ${({ isDisabled }) => {
        return isDisabled
            ? `color: ${neutralDark10};`
            : `
                color: ${buttonPrimary};
                &:hover {
                    color: ${buttonPrimaryHover};
                }
                &:active {
                    color: ${buttonPrimaryPressed};
                }
            `;
    }}
`;
